export default __webpack_public_path__ + "static/media/dish.c770d81a.png";